<mat-card>
  <mat-card-content>
    <div class="flex flex-col w-11/12">
      <div class="flex flex-col" style="overflow-x:auto">
        <div class="flex flex-row">

          <table mat-table [dataSource]="dataSource" multiTemplateDataRows matSort fxFlex="100"
            #TableSort="matSort" class="mat-elevation-z8">

            <ng-container matColumnDef="complaintId">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint ID</th>
              <td mat-cell *matCellDef="let complaint"><a (click)="gotoComplaint(complaint.complaintId)">{{complaint.complaintId}}</a></td>
            </ng-container>
            <ng-container matColumnDef="businessName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Business Name</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.businessName}}</td>
            </ng-container>
            <ng-container matColumnDef="complaintDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Complaint Date</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.complaintDate}}</td>
            </ng-container>
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Address</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.address}}</td>
            </ng-container>
            <ng-container matColumnDef="city">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.city}}</td>
            </ng-container>
            <ng-container matColumnDef="zipCode">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip Code</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.zipCode}}</td>
            </ng-container>
            <ng-container matColumnDef="requiredVisitDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Site Visit Due Date</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.requiredVisitDate}}</td>
            </ng-container>
            <ng-container matColumnDef="requiredImplementationDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Remediation Plan Due Date</th>
              <td mat-cell *matCellDef="let complaint">{{complaint.requiredImplementationDate}}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="expansion-element-row"></tr>

          </table>

        </div>
        <mat-paginator [pageSizeOptions]="[5, 20, 100]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
      </div>

    </div>
  </mat-card-content>
</mat-card>